import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTypeFieldValueAction,
  getTypeFieldValueAction,
  updateTypeFieldValueAction,
} from "../../Actions/TypeFieldAction/TypeFieldAction";
import { useParams } from "react-router-dom";
import { RxUpdate } from "react-icons/rx";
import { MdOutlineSaveAlt } from "react-icons/md";
import { FaPlus, FaTrash } from "react-icons/fa";
import TypeFieldDropdownModal from "../../Modal/TypeFieldModal/TypeFieldDropdownModal";

const TypeFieldDropdownValuePage = () => {
  const [indexx, setIndexx] = useState(null);
  const [state, setState] = useState({
    value: "",
    id: "",
  });
  const [isOpenModal, setIsOpenMpdal] = useState(false);
  const { id } = useParams();
  const getTypeFieldValue = useSelector((state) => state.getTypeFieldValue);
  const dispatch = useDispatch();
  const { typeFieldValues } = getTypeFieldValue;
  useEffect(() => {
    dispatch(getTypeFieldValueAction(id));
  }, []);
  const handleUpdate = () => {
    dispatch(updateTypeFieldValueAction(state.id, state.value, id));
    setIndexx(null);
    setState({
      value: "",
      id: "",
    });
  };

  const handleDelete = (typeFeildValueId) => {
    dispatch(deleteTypeFieldValueAction(typeFeildValueId, id));
  };
  return (
    <div className="w-11/12 m-auto bg-white mt-2">
      <div className="flex justify-end mt-2  ">
        <button
          onClick={() => setIsOpenMpdal(true)}
          className="btn-info flex gap-2 mt-2 mr-1 items-center"
        >
          Add Value <FaPlus />
        </button>
      </div>

      <div className="parent-table">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Value</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {typeFieldValues?.map((type, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  {index == indexx ? (
                    <td className="w-[75%]">
                      <input
                        type="text"
                        placeholder="Value"
                        className="input w-full"
                        onChange={(e) =>
                          setState({ ...state, value: e.target.value })
                        }
                        value={state.value}
                      />
                    </td>
                  ) : (
                    <td className="w-[65%]">{type.value}</td>
                  )}

                  {index == indexx ? (
                    <td>
                      <button
                        onClick={handleUpdate}
                        className="btn-info flex gap-2 items-center "
                      >
                        Save <MdOutlineSaveAlt />
                      </button>
                    </td>
                  ) : (
                    <td>
                      <div className="flex gap-2 items-center">
                        <button
                          onClick={() => {
                            setIndexx(index);

                            setState({
                              ...state,
                              value: type.value,
                              id: type.id,
                            });
                          }}
                          className="btn-primary flex gap-2 items-center "
                        >
                          Update
                          <RxUpdate />
                        </button>
                        <button
                          onClick={() => handleDelete(type.id)}
                          className="btn-danger flex gap-2 items-center"
                        >
                          {" "}
                          Delete <FaTrash />{" "}
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isOpenModal && (
        <TypeFieldDropdownModal
          closeModal={() => setIsOpenMpdal(false)}
          typeFieldId={id}
        />
      )}
    </div>
  );
};

export default TypeFieldDropdownValuePage;
